'use strict';

import toasts from './toast-notify';

// copy text to the clipboard
function handleCopyText() {
    $(document).on('click', '.copy-promotion-code', function (e) {
        e.preventDefault();
        var copyText = $(this).parent().find("#promotion-to-copy").val();
        navigator.clipboard.writeText(copyText);
        if($(this).parent().parent().hasClass("cart-promo-wrapper")) {
            toasts.init($('#clicktocopycode').val(), 'active animate__fadeInDownToast', 'icon icon-compare');
        } else {
            toasts.init($('#clicktocopy').val(), 'active animate__fadeInDownToast', 'icon icon-compare');
        }
    })
    $('.copy-promotion-code .link-redirection').on('click', function (e) {
        $('.copy-promotion-code').trigger('click');
        setTimeout(() => {
            var baseurl = window.location.origin;
            var anchorUrl = baseurl + $('.copy-promotion-code .link-redirection').attr('href');
            window.location.replace(anchorUrl);
        }, 300);
    })
}

var copyTextToClipboard = {	
	init: function () {
        handleCopyText();
	}
};

export default copyTextToClipboard;